export class GetKxAccommodationApplicationForApplicantResponse {
    StatusDescription: string;
    StatusFlag: string;
}